import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["checkbox", "label"]

  connect() {
    this.updateTooltip()
    this.checkboxTarget.addEventListener('change', this.updateTooltip.bind(this))
  }

  disconnect() {
    this.checkboxTarget.removeEventListener('change', this.updateTooltip.bind(this))
    const tooltipInstance = M.Tooltip.getInstance(this.labelTarget)
    if (tooltipInstance) {
      tooltipInstance.destroy()
    }
  }

  updateTooltip() {
    const isChecked = this.checkboxTarget.checked
    const tooltipText = isChecked ?
      this.labelTarget.dataset.checkedTooltip :
      this.labelTarget.dataset.uncheckedTooltip
    
    this.labelTarget.setAttribute('data-tooltip', tooltipText)
    
    let tooltipInstance = M.Tooltip.getInstance(this.labelTarget)
    if (tooltipInstance) {
      tooltipInstance.destroy()
    }
    tooltipInstance = M.Tooltip.init(this.labelTarget, {
      enterDelay: this.element.dataset.tooltipEnterDelay || 200,
    })
  }
}